import gql from 'graphql-tag';

export const QUERY = gql([
    `
query QueryJeuContents($filter: String!)
{
  queryJeuContents(top: 1, skip: 0, filter: $filter) {
    data {
      pageTitle {
        iv
      }
      picture {
        iv {
          fileSize
          url
        }
      }
      logo {
        iv {
          fileSize
          url
        }
      }
      partnerLogo {
        iv {
          fileSize
          url
        }
      }
      title {
        iv
      }
      titleTextColor {
        iv
      }
      subTitle {
        iv
      }
      subTitleTextColor {
        iv
      }
      formTextColor {
        iv
      }
      mentions {
        iv
      }

      finishedGameText { iv }
      finishedGameTextColor { iv }
      finishedGameFontSize { iv }
    }
  }
}
`,
]);
